import { AppThunk } from '../../../../../../store/types';
import { BookEffects } from '../../../../../../effects/bookEffects';
import { TBookVoices } from '../../../../../../../common/rest/endlessBook/endlessBookRest';

export class BookVoiceSettingsEvents {

	public static onLoadVoices(): AppThunk<Promise<TBookVoices | null>> {
		return () => BookEffects.loadVoices();
	}

	public static onGetSample(languageName: string, voiceName: string): AppThunk<Promise<string | null>> {
		return () => BookEffects.getVoiceSample(languageName, voiceName);
	}

	public static onSetVoice(languageCode: string, voiceName: string): AppThunk<Promise<Record<string, string> | null>> {
		return () => BookEffects.setVoice(languageCode, voiceName);
	}

}
